<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card style="overflow-y: hidden; height: 80vh;">
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Gestion des sous-rubriques
            </strong>
          </div>
          <b-row>
            <b-col sm="12">
              <button type="button" @click="createRubrique()" class="btn btn-success mb-2 pull-right"><i class="fa fa-plus"></i> Créer une nouvelle sous-rubrique</button>
            </b-col>
          </b-row>
          <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-scroll-y="scrollHandle">
            <h5>Liste des sous-rubriques</h5>

            <div v-if="isEmpty(sousRubriques)">Aucune sous-rubrique n'est créée pour l'instant</div>
            <SlickList v-else lockAxis="y" v-model="sousRubriques" class="list-group" :useDragHandle="true" @input="sorted()">
              <div v-for="(sousRubrique, index) in sousRubriques" :key="index">
                <handleSlickItem  :index="index"  :item="sousRubrique"  groupKey="sousRubrique" :id="`item-${sousRubrique.id}`" role="tab" class="block-sousRubrique">
                  {{ sousRubrique.libelle }} <i v-if="canManage()" class="fa fa-trash pull-right text-danger" @click="removeSousRubrique(sousRubrique.id)"></i>
                </handleSlickItem>
                <b-collapse :id="`collapse-${sousRubrique.id}`" class="" :accordion="`accordion-sousRubrique`" role="tabpanel" :visible="visible">
                  <b-card class="mb-0">
                    <p :id="`infosSousRubrique-${sousRubrique.id}`" class="card-text">
                      <b-row class="my-1">
                        <b-col sm="12">
                          <i v-if="canManage()" class="fa fa-pencil pull-right clickable" @click="editSousRubrique(sousRubrique)"></i>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label for="libelle">Libellé :</label>
                        </b-col>
                        <b-col sm="9">
                          <b-form-input id="libelle" :value="sousRubrique.libelle" size="sm" placeholder="Entrer le nom de la sousRubrique" :class="{hasError: errors.libelle !== ''}" disabled></b-form-input>
                          <span class='field-error'>{{ errors.libelle }}</span>
                        </b-col>
                      </b-row>
                    </p>
                    <p :id="`editSousRubrique-${sousRubrique.id}`" class="card-text d-none">
                      <b-row class="my-1">
                        <b-col sm="3">
                          <label for="libelle">Libellé :</label>
                        </b-col>
                        <b-col sm="9">
                          <b-form-input id="libelle" v-model="libelle" size="sm" placeholder="Entrer le nom de la sousRubrique" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                          <span class='field-error'>{{ errors.libelle }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="12">
                          <button type="button" @click="save()" class="btn btn-primary  pull-right">Valider</button>
                          <button type="button" @click="cancelEditRubrique(sousRubrique.id)" class="btn btn-light pull-right mr-2">Annuler</button>
                        </b-col>
                      </b-row>
                    </p>
                  </b-card>
                </b-collapse>
              </div>
            </SlickList >
          </VuePerfectScrollbar>
        </b-card>
      </b-col>
    </b-row>

    <modal-sousRubrique></modal-sousRubrique>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import { SlickList } from 'vue-slicksort';
import handleSlickItem from '@/components/SlickCollapseItem';
import modalSousRubrique from './ModalSousRubrique';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {isEmpty} from "@/utils/fileHelper";
import {espaceBibliothequeRules as rules, hasRule} from '@/utils/rulesHelper';


export default {
  components: {
    SlickList,
    handleSlickItem,
    VuePerfectScrollbar,
    modalSousRubrique
  },
  data() {
    return {
      isEmpty,
      showColorPicker: [],
      libelle: '',
      libelle_technique: '',
      sousRubriques: [],
      sousRubriqueId: '',
      ordre: '',
      visible: false,
      errors: {
        libelle: '',
      }
    }
  },
  created() {
    this.getSousRubriques();

    this.$event.on('refresh-sous-rubrique-document', () => {
      this.getSousRubriques();
    });
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    }
  },
  methods: {
    scrollHandle (evt) {
      // console.log(evt)
      // console.log(this.)
    },
    createRubrique() {
      this.$bvModal.show('modal-sous-rubrique');
    },
    sorted(event) {
      // console.log(event)
      // console.log(this.sousRubriques)
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'sousRubriques': this.sousRubriques
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/espaceBibliotheque/sous-rubriques/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    getSousRubriques() {
      this.$store.commit("IS_LOADING", true);
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/sous-rubriques')
        .then(response => {
          this.sousRubriques = response.data.sousRubriques;
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des sous-rubriques. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
    },
    save(sousRubrique) {
      if (this.validateData()) {
        let self = this;
        let dataPost = {};

        dataPost.libelle = this.libelle;
        dataPost.sousRubriqueId = this.sousRubriqueId;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceBibliotheque/sous-rubrique", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Modification avec succès",
              text: "La sousRubrique a bien été modifiée",
              showConfirmButton: false,
              timer: 5000
            });

            this.toggleEditRubrique(this.sousRubriqueId, 'cancel');
            this.getSousRubriques();
            this.resetInput();
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text:
                "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    clearErrors() {
      this.errors.libelle = '';
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      if (isEmpty(this.libelle)) {
        this.errors.libelle = 'Le libellé est obligatoire';
        valid = false;
      }
      return valid;
    },
    toggleEditRubrique(sousRubriqueId, action) {
      let itemToShow
      let itemToHide

      if (action === 'cancel') {
        itemToShow = document.getElementById('infosSousRubrique-'+sousRubriqueId)
        itemToHide = document.getElementById('editSousRubrique-'+sousRubriqueId)
      } else if (action === 'edit') {
        itemToHide = document.getElementById('infosSousRubrique-'+sousRubriqueId)
        itemToShow = document.getElementById('editSousRubrique-'+sousRubriqueId)
      }

      itemToHide.classList.remove("d-block")
      itemToHide.classList.add("d-none")
      itemToShow.classList.remove("d-none")
      itemToShow.classList.add("d-block")
    },
    editSousRubrique(sousRubrique) {
      this.resetInput();
      this.libelle = sousRubrique.libelle;
      this.sousRubriqueId = sousRubrique.id;

      this.toggleEditRubrique(sousRubrique.id, 'edit')
    },
    toggleOnRemoveItem(sousRubriqueId, isConfirmed) {
      let itemToHide = document.getElementById('item-' + sousRubriqueId)
      // quand on clique sur l'item (pas sur l'icon supprimer)
      if (itemToHide.classList.contains('active')) {
        itemToHide.classList.remove("active")
      } else {
        if (isConfirmed == false) {
          // quand on clique sur l'icon supprimer sans ouvrir l'item, on le referme directement
          this.$root.$emit('bv::toggle::collapse', 'collapse-' + sousRubriqueId)
        }
      }
    },
    removeSousRubrique(sousRubriqueId) {
      this.toggleOnRemoveItem(sousRubriqueId, false)
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette sousRubrique ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!isEmpty(result.dismiss) && result.dismiss === 'cancel') {
            this.toggleOnRemoveItem(sousRubriqueId, true)
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .delete("/espaceBibliotheque/sous-rubrique/delete/"+sousRubriqueId)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'La sousRubrique a bien été supprimée',showConfirmButton: false, timer: 5000})
              this.getSousRubriques()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue pendant la suppression de la sous-rubrique, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            })
          }
        })
    },
    cancelEditRubrique(sousRubriqueId) {
      this.resetInput();
      this.toggleEditRubrique(sousRubriqueId, 'cancel')
    },
    resetInput() {
      this.libelle = '';
      this.sousRubriqueId = '';
    },
    canManage() {
      return hasRule(rules.CAN_MANAGE_RUBRIQUE)
    },
  }
}
</script>

<style scoped>
  .scroll-area {
    position: absolute;
    height: 60vh;
    width: 90%;
    /*margin: auto;*/
  }
</style>
